(() => {
  if (customElements.get('okova-setup-preview')) return;
  customElements.define('okova-setup-preview', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.product-section');
      if (!this.section) return;
      this.abort = new AbortController();
      this.schedule = () => queueMicrotask(() => { if (this.isConnected) this.sync(); });
      this.section.addEventListener('change', this.schedule, { capture: true, signal: this.abort.signal });
      this.section.addEventListener('theme:variant:change', this.schedule, { signal: this.abort.signal });
      document.addEventListener('DOMContentLoaded', this.schedule, { once: true, signal: this.abort.signal });
      this.schedule();
    }
    disconnectedCallback() { this.abort?.abort(); }
    sync() {
      const builder = this.section.querySelector('[data-okova-variant-builder]');
      const selects = Array.from(this.section.querySelectorAll('form[data-product-form] .product__form__select'));
      this.config ||= JSON.parse(this.querySelector('[data-setup-config]').textContent);
      const variant = this.config.variants.find(item => selects.length === item.options.length && selects.every((select, i) => select.value === item.options[i]));
      if (!variant || builder?.dataset.initialized !== 'true') { this.hidden = true; return; }
      const [connection, material] = variant.options.map(value => value.trim().toLowerCase());
      const l = this.config.labels;
      let photo, title, description;
      if (connection === 'clip on tail no plug' && material === 'clip on tail no plug') {
        photo = 'clipon'; title = l.clipon_title; description = l.clipon_text;
      } else {
        const standard = connection.match(/^(small|medium|large) (attached|detachable)$/);
        const tug = connection.match(/^(small|medium|large) tug plug \(only metal plug\)$/);
        if (standard && ['silver metal plug', 'black silicone plug'].includes(material)) {
          const type = material === 'black silicone plug' ? 'silicone' : 'metal';
          photo = `${type}-${standard[2]}`;
          title = `${l[type]} · ${l[standard[2]]}`;
          description = l[`${standard[2]}_text`].replace('__size__', l[standard[1]].toLowerCase()).replace('__material__', l[`${type}_material`]);
        } else if (tug && material === 'silver metal plug') {
          photo = 'tug'; title = `${l.tug} · ${l.detachable}`;
          description = l.tug_text.replace('__size__', l[tug[1]].toLowerCase());
        }
      }
      if (!title) { this.hidden = true; return; }
      this.querySelectorAll('[data-setup-photo]').forEach(img => { img.hidden = img.dataset.setupPhoto !== photo; });
      this.querySelector('.okova-setup-preview__photos').dataset.photo = photo;
      const heading = this.querySelector('[data-setup-title]');
      const body = this.querySelector('[data-setup-description]');
      if (heading.textContent !== title) heading.textContent = title;
      if (body.textContent !== description) body.textContent = description;
      this.hidden = false;
    }
  });
})();

